
import user from "./plugins/user";
import device from './plugins/device'
import Vue from 'vue'
import './plugins/auth'

if (!user.user || !user.user.t) {
    window.location.href = "/login.html";
}

let statusMap = ['production', 'standby', 'maintenance', 'error', 'sleep'];

Vue.prototype.confirm = function (msg, callback) {
    var $ = window.$;
    var modal = $('#modal-check-remove');
    $('.msg', modal).html(msg);
    $('.ok', modal).off('click');
    $('.ok', modal).click(() => {
        modal.modal('hide');
        callback();
    });
    modal.modal();
}

Vue.prototype.$bvModal = {
    show(id) {
        window.$('#' + id).modal();
    },
    hide(id) {
        window.$('#' + id).modal('hide');
    }
};

export default {
    name: "App",
    data() {
        return {
            user: user.user,
            time: moment().format('YYYY-MM-DD HH:mm:ss'),
            devices: [],
            device: null
        };
    },
    async mounted() {
        this.devices = await this.$api.getDevices();
        if (device.device) {
            this.device = await this.$api.getDevice();
            console.log(this.device);
        } else {
            window.$('.btn-close-sm').remove();
            window.$('#modal-select-all-machine').modal({
                backdrop: 'static',
                keyboard: false
            });
            return;
        }
        setInterval(() => {
            this.time = moment().format('YYYY-MM-DD HH:mm:ss');
        }, 1000);
        setInterval(async () => {
            var newDevices = await this.$api.getDevices();
            var map = {};
            this.devices.forEach(a => {
                a.Devices.forEach(d => {
                    map[d.CustomerDeviceID] = d;
                });
            });
            newDevices.forEach(a => {
                a.Devices.forEach(d => {
                    var old = map[d.CustomerDeviceID];
                    if (old.Status != d.Status) {
                        var txt = `
                              <div class="notification-window">
                                <ul>
                                  <li style="bottom: 0">
                                    <a href="javascript:void()">
                                      <div class="header clearfix">
                                        <div class="pull-left">
                                          <span class="location">${a.Name}</span>
                                          <span class="machine-id">${d.Name}</span>
                                        </div>
                                        <div class="pull-right">
                                          <div class="time">${window.filters.dateTimeFormat(moment())}</div>
                                        </div>
                                      </div>
                                      <div class="body mg-top-12">
                                        <!-- 加上 data-status 來改變狀態圖標-->
                                        <p
                                          class="status-item"
                                          data-status="${statusMap[d.Status]}"
                                        >${d.Message}</p>
                                      </div>
                                    </a>
                                  </li>
                                </ul>
                              </div>`;
                        Vue.notify({
                            group: 'notify',
                            duration: -1,
                            text: txt
                        });
                    }
                });
            });
            this.devices = newDevices;
        }, config.interval);
    },
    methods: {
        select(d) {
            device.setDevice(d.CustomerDeviceID);
            location.reload();
        },
        logout() {
            user.logout();
            device.clear();
            window.location.href = "/";
        }
    },
    filters: {
        deviceStatus(value) {
            return statusMap[value];
        }
    }
};